/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTO } from "../models/ApiResponseDTO";
import type { ApiResponseDTOCredentialVerifyFailureDTO } from "../models/ApiResponseDTOCredentialVerifyFailureDTO";
import type { ApiResponseDTONextOfKinDTO } from "../models/ApiResponseDTONextOfKinDTO";
import type { ApiResponseDTONinResponseDTO } from "../models/ApiResponseDTONinResponseDTO";
import type { ApiResponseDTONINVerificationResponseDTO } from "../models/ApiResponseDTONINVerificationResponseDTO";
import type { ApiResponseDTORegistrationDetailsRequestDTO } from "../models/ApiResponseDTORegistrationDetailsRequestDTO";
import type { ApiResponseDTORegistrationDetailsResponseDTO } from "../models/ApiResponseDTORegistrationDetailsResponseDTO";
import type { ApiResponseDTORegistrationIdResponseDTO } from "../models/ApiResponseDTORegistrationIdResponseDTO";
import type { ApiResponseDTOResetPasscodeResponseDTO } from "../models/ApiResponseDTOResetPasscodeResponseDTO";
import type { ApiResponseDTOSelfieStatusResponseDTO } from "../models/ApiResponseDTOSelfieStatusResponseDTO";
import type { ApiResponseDTOSignInResponseDTO } from "../models/ApiResponseDTOSignInResponseDTO";
import type { ApiResponseDTOSubmitDocumentResponseDTO } from "../models/ApiResponseDTOSubmitDocumentResponseDTO";
import type { ApiResponseDTOSubmitSelfieResponseDTO } from "../models/ApiResponseDTOSubmitSelfieResponseDTO";
import type { ApiResponseDTOTaxIdentificationNumberResponseDTO } from "../models/ApiResponseDTOTaxIdentificationNumberResponseDTO";
import type { ApiResponseDTOUserDetailDTO } from "../models/ApiResponseDTOUserDetailDTO";
import type { ApiResponseDTOUserDetailsByCifDTO } from "../models/ApiResponseDTOUserDetailsByCifDTO";
import type { ApiResponseDTOUserDTO } from "../models/ApiResponseDTOUserDTO";
import type { ApiResponseDTOVoid } from "../models/ApiResponseDTOVoid";
import type { ApiResponseDTOZenzAccountVerifyResponseDTO } from "../models/ApiResponseDTOZenzAccountVerifyResponseDTO";
import type { BvnRequestRecord } from "../models/BvnRequestRecord";
import type { CreatePasscodeDTO } from "../models/CreatePasscodeDTO";
import type { NextOfKinDTO } from "../models/NextOfKinDTO";
import type { NINVerificationRequestDTO } from "../models/NINVerificationRequestDTO";
import type { PreferencesDTO } from "../models/PreferencesDTO";
import type { RegistrationDetailsRequestDTO } from "../models/RegistrationDetailsRequestDTO";
import type { RegistrationIdRequestDTO } from "../models/RegistrationIdRequestDTO";
import type { ResetPasscodeRecord } from "../models/ResetPasscodeRecord";
import type { SessionBalanceUpdateDTO } from "../models/SessionBalanceUpdateDTO";
import type { SubmitDocumentRequestDTO } from "../models/SubmitDocumentRequestDTO";
import type { SubmitSelfieRequestDTO } from "../models/SubmitSelfieRequestDTO";
import type { TinRequestDTO } from "../models/TinRequestDTO";
import type { ToggleWalletBalanceRequestDTO } from "../models/ToggleWalletBalanceRequestDTO";
import type { UpdateMerchantEmailRequestDTO } from "../models/UpdateMerchantEmailRequestDTO";
import type { UserBusinessDTO } from "../models/UserBusinessDTO";
import type { UserKycDataDTO } from "../models/UserKycDataDTO";
import type { UserPublicProfileDTO } from "../models/UserPublicProfileDTO";
import type { VerifyPasscodeRequestDTO } from "../models/VerifyPasscodeRequestDTO";
import type { VerifySelfieAndGhCardRequestDTO } from "../models/VerifySelfieAndGhCardRequestDTO";
import type { ZenzAccountVerifyRequestDTO } from "../models/ZenzAccountVerifyRequestDTO";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class UsersApiService {
  /**
   * Get user details
   * Retrieves the user details
   * @returns ApiResponseDTOUserDetailDTO OK
   * @throws ApiError
   */
  public static getUser(): CancelablePromise<ApiResponseDTOUserDetailDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/user",
      errors: {
        403: `Forbidden`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Get business details
   * Returns business details for the authenticated user
   * @returns UserBusinessDTO OK
   * @throws ApiError
   */
  public static getUserBusinessDetails(): CancelablePromise<UserBusinessDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/user/business",
      errors: {
        403: `Forbidden`,
        404: `Not Found`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Validate the User BVN
   * Validate the user BVN and return user details
   * @param requestBody
   * @returns ApiResponseDTOUserDTO OK
   * @throws ApiError
   */
  public static verifyBvn(
    requestBody: BvnRequestRecord
  ): CancelablePromise<ApiResponseDTOUserDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/bvn",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        403: `Forbidden`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Change user passcode
   * Use this endpoint to change user passcode
   * @param requestBody
   * @returns ApiResponseDTOSignInResponseDTO OK
   * @throws ApiError
   */
  public static changePasscode(
    requestBody: CreatePasscodeDTO
  ): CancelablePromise<ApiResponseDTOSignInResponseDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/change-passcode",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        403: `Forbidden`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Get user details by cif and profile
   * Retrieves the user details by cif and profile
   * @param cif
   * @param profile
   * @returns ApiResponseDTOUserDetailsByCifDTO OK
   * @throws ApiError
   */
  public static getUserByCifAndProfile(
    cif: string,
    profile: string
  ): CancelablePromise<ApiResponseDTOUserDetailsByCifDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/user/cif",
      query: {
        cif: cif,
        profile: profile,
      },
      errors: {
        403: `Forbidden`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Submit Document
   * Submit the document and list of liveliness photos to be verified by the SmileID
   * @param requestBody
   * @returns ApiResponseDTOSubmitDocumentResponseDTO OK
   * @throws ApiError
   */
  public static postDocumentVerificationMultipart1(
    requestBody: SubmitDocumentRequestDTO
  ): CancelablePromise<ApiResponseDTOSubmitDocumentResponseDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/document",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        403: `Forbidden`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Update verified user email
   * Updates the authenticated user's email after OTP verification
   * @param xMfaEmail
   * @param requestBody
   * @returns ApiResponseDTOVoid OK
   * @throws ApiError
   */
  public static updateEmail(
    xMfaEmail: string,
    requestBody: UpdateMerchantEmailRequestDTO
  ): CancelablePromise<ApiResponseDTOVoid> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/user/email",
      headers: {
        "X-MFA-Email": xMfaEmail,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        403: `Forbidden`,
        404: `Not Found`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Get KYC data
   * Returns sensitive KYC data for the authenticated user (BVN, Ghana Card, CIF)
   * @returns UserKycDataDTO OK
   * @throws ApiError
   */
  public static getUserKycData(): CancelablePromise<UserKycDataDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/user/kyc-data",
      errors: {
        403: `Forbidden`,
        404: `Not Found`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Get Next of Kin
   * Retrieve next of kin information.
   * @returns ApiResponseDTONextOfKinDTO OK
   * @throws ApiError
   */
  public static getNextOfKin(): CancelablePromise<ApiResponseDTONextOfKinDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/user/next-of-kins",
      errors: {
        403: `Forbidden`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Submit Next of Kin
   * Submit the next of kin information
   * @param requestBody
   * @returns ApiResponseDTONextOfKinDTO OK
   * @throws ApiError
   */
  public static postNextOfKin(
    requestBody: NextOfKinDTO
  ): CancelablePromise<ApiResponseDTONextOfKinDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/next-of-kins",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        403: `Forbidden`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Get NIN Verification Status
   * Get verification status of National Identification Number
   * @returns ApiResponseDTONINVerificationResponseDTO OK
   * @throws ApiError
   */
  public static getNinVerificationStatus(): CancelablePromise<ApiResponseDTONINVerificationResponseDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/user/nin-verification",
      errors: {
        403: `Forbidden`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Submit NIN for Verification
   * Submit National Identification Number for verification
   * @param requestBody
   * @returns ApiResponseDTOVoid OK
   * @throws ApiError
   */
  public static postSubmitNinVerification(
    requestBody: NINVerificationRequestDTO
  ): CancelablePromise<ApiResponseDTOVoid> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/nin-verification",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        403: `Forbidden`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Verify the current passcode
   * Checks the merchant's current passcode without changing anything and without issuing a session. Gates the change-passcode journey.
   * @param requestBody
   * @returns ApiResponseDTOCredentialVerifyFailureDTO OK
   * @throws ApiError
   */
  public static verifyCurrentPasscode(
    requestBody: VerifyPasscodeRequestDTO
  ): CancelablePromise<ApiResponseDTOCredentialVerifyFailureDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/passcode/verify",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        401: `Passcode incorrect`,
        403: `Forbidden`,
        404: `Not Found`,
        422: `Unprocessable Entity`,
        429: `Too many incorrect attempts`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Get minimal user profile
   * Returns minimal public profile of the authenticated user
   * @returns UserPublicProfileDTO OK
   * @throws ApiError
   */
  public static getUserProfile(): CancelablePromise<UserPublicProfileDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/user/profile",
      errors: {
        403: `Forbidden`,
        404: `Not Found`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Get Registration Details Verification Status
   * Get the Registration Details verification status.
   * @returns ApiResponseDTORegistrationDetailsRequestDTO OK
   * @throws ApiError
   */
  public static getRegistrationDetailsVerificationStatus(): CancelablePromise<ApiResponseDTORegistrationDetailsRequestDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/user/registration-details",
      errors: {
        403: `Forbidden`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Save the Registration Details
   * Save the user Registration Number (CAC or RC) and Tax Identification Number (TIN) through Smile ID. Kept for backward compatibility; new clients use the registration-details/registration-id, individual-tax-id and tin endpoints
   * @param requestBody
   * @returns ApiResponseDTORegistrationDetailsResponseDTO OK
   * @throws ApiError
   */
  public static setRegistrationDetails(
    requestBody: RegistrationDetailsRequestDTO
  ): CancelablePromise<ApiResponseDTORegistrationDetailsResponseDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/registration-details",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        403: `Forbidden`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Submit Registration Details for review
   * Save the RC and TIN the user typed in because YouVerify was unavailable, without calling any provider. The step stays pending while the Back Office reviews them
   * @param requestBody
   * @returns ApiResponseDTORegistrationDetailsResponseDTO OK
   * @throws ApiError
   */
  public static submitRegistrationDetailsForReview(
    requestBody: RegistrationDetailsRequestDTO
  ): CancelablePromise<ApiResponseDTORegistrationDetailsResponseDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/registration-details/manual-review",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        403: `Forbidden`,
        422: `Unprocessable Entity`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Verify individual tax ID
   * Verify an individual tax ID using the NIN already stored for the user. No request body is needed; one sent by older clients is ignored
   * @returns ApiResponseDTOTaxIdentificationNumberResponseDTO OK
   * @throws ApiError
   */
  public static verifyIndividualTaxId(): CancelablePromise<ApiResponseDTOTaxIdentificationNumberResponseDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/registration-details/individual-tax-id",
      errors: {
        400: `Bad Request`,
        403: `Forbidden`,
        404: `Not Found`,
        422: `Unprocessable Entity`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Get stored NIN
   * Get the user's stored NIN
   * @returns ApiResponseDTONinResponseDTO OK
   * @throws ApiError
   */
  public static getRegistrationDetailsNin(): CancelablePromise<ApiResponseDTONinResponseDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/user/registration-details/nin",
      errors: {
        400: `Bad Request`,
        403: `Forbidden`,
        404: `Not Found`,
        422: `Unprocessable Entity`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Verify registration ID
   * Verify and save the user's registration ID
   * @param requestBody
   * @returns ApiResponseDTORegistrationIdResponseDTO OK
   * @throws ApiError
   */
  public static verifyRegistrationId(
    requestBody: RegistrationIdRequestDTO
  ): CancelablePromise<ApiResponseDTORegistrationIdResponseDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/registration-details/registration-id",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        403: `Forbidden`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Verify TIN
   * Verify and save the user's tax identification number
   * @param requestBody
   * @returns ApiResponseDTOTaxIdentificationNumberResponseDTO OK
   * @throws ApiError
   */
  public static verifyTin(
    requestBody: TinRequestDTO
  ): CancelablePromise<ApiResponseDTOTaxIdentificationNumberResponseDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/registration-details/tin",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        403: `Forbidden`,
        404: `Not Found`,
        422: `Unprocessable Entity`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Reset user passcode
   * Use this endpoint to reset user passcode, it is expected that Passcode reset between sent and verified before calling this endpoint
   * @param requestBody
   * @returns ApiResponseDTOResetPasscodeResponseDTO OK
   * @throws ApiError
   */
  public static resetPasscode(
    requestBody: ResetPasscodeRecord
  ): CancelablePromise<ApiResponseDTOResetPasscodeResponseDTO> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/user/resetpasscode",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        403: `Forbidden`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Submit Selfie
   * Submit the selfie and list of liveliness photos to be verified by the SmileID
   * @param requestBody
   * @returns ApiResponseDTOSubmitSelfieResponseDTO OK
   * @throws ApiError
   */
  public static postSubmitSelfie(
    requestBody: SubmitSelfieRequestDTO
  ): CancelablePromise<ApiResponseDTOSubmitSelfieResponseDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/selfie",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        403: `Forbidden`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Verify Selfie
   * Verify the selfie with card id
   * @param requestBody
   * @returns ApiResponseDTOVoid OK
   * @throws ApiError
   */
  public static verifySelfieAndGhanaCard(
    requestBody: VerifySelfieAndGhCardRequestDTO
  ): CancelablePromise<ApiResponseDTOVoid> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/selfie-verify",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        403: `Forbidden`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Get the submitted Selfie status
   * Retrieve the selfie status submitted to SmileID
   * @param jobId
   * @returns ApiResponseDTOSelfieStatusResponseDTO OK
   * @throws ApiError
   */
  public static getSelfieStatus(
    jobId: string
  ): CancelablePromise<ApiResponseDTOSelfieStatusResponseDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/user/selfie/{jobId}",
      path: {
        jobId: jobId,
      },
      errors: {
        403: `Forbidden`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Toggle user wallet balance to show or not
   * Toggle user wallet balance to show or not
   * @param requestBody
   * @returns ApiResponseDTO OK
   * @throws ApiError
   */
  public static toggleWalletBalance(
    requestBody: ToggleWalletBalanceRequestDTO
  ): CancelablePromise<ApiResponseDTO> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/user/toggle-wallet-balance",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        403: `Forbidden`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Update user session
   * Use this endpoint to update the users session balance and cash balance per transaction.
   * @param requestBody
   * @returns ApiResponseDTOVoid OK
   * @throws ApiError
   */
  public static updateSessionBalance(
    requestBody: SessionBalanceUpdateDTO
  ): CancelablePromise<ApiResponseDTOVoid> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/user/update-session-balance",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        403: `Forbidden`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Submit Selfie (Multipart)
   * Submit selfie and liveness photos as multipart file uploads
   * @param formData
   * @returns ApiResponseDTOSubmitSelfieResponseDTO OK
   * @throws ApiError
   */
  public static postSubmitSelfieMultipart(formData?: {
    files: Array<Blob>;
    metadata: string;
  }): CancelablePromise<ApiResponseDTOSubmitSelfieResponseDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/upload-selfie",
      formData: formData,
      mediaType: "multipart/form-data",
      errors: {
        403: `Forbidden`,
        404: `Not Found`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Get user details by user Id
   * Retrieves the user details by user Id
   * @param userId
   * @returns ApiResponseDTOUserDetailsByCifDTO OK
   * @throws ApiError
   */
  public static getUserByUserId(
    userId: string
  ): CancelablePromise<ApiResponseDTOUserDetailsByCifDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/user/userid",
      query: {
        userId: userId,
      },
      errors: {
        403: `Forbidden`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Verify Zenith Account
   * Verify if Zenith account number is valid.
   * @param requestBody
   * @returns ApiResponseDTOZenzAccountVerifyResponseDTO OK
   * @throws ApiError
   */
  public static verifyZenzAccountNumber(
    requestBody: ZenzAccountVerifyRequestDTO
  ): CancelablePromise<ApiResponseDTOZenzAccountVerifyResponseDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/zenith-account/verify",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        403: `Forbidden`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Get user preferences
   * Retrieves user preferences by userId
   * @param userId
   * @returns PreferencesDTO OK
   * @throws ApiError
   */
  public static getPreferences(
    userId: string
  ): CancelablePromise<PreferencesDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/user/{userId}/preferences",
      path: {
        userId: userId,
      },
      errors: {
        403: `Forbidden`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }
}
